module.exports = __webpack_public_path__ + "static/media/ec.3bafd071.svg";